import { render, staticRenderFns } from "./CertificateDialog.vue?vue&type=template&id=1fbbf6dc"
import script from "./CertificateDialog.vue?vue&type=script&lang=js"
export * from "./CertificateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports